<button class="btn btn-primary" id="addCustomerButton" data-toggle="modal" data-target="#addNewCustomerModal" hidden>{{ 'Standard.NewCustomer' | translate }}</button>

<div id="addNewCustomerModal" class="modal fade">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{{ 'Standard.NewCustomer' | translate }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <i class="fa fa-window-close red" aria-hidden="true"></i>
                </button>
            </div>
            <div class="modal-body">
                <div class="card">
                    <div class="card-header">
                        <div class="card-title">{{ 'Standard.Customer' | translate }}</div>
                    </div>
                    <div class="card-body d-flex flex-column gap-3">
                        <div class="w-100 position-relative">
                            <div class="text-muted text-small">{{ 'Company.VatNumber' | translate }}</div>
                            <input type="text" class="form-control w-100" [(ngModel)]="customer.cvr" (input)="cvr($event)">
                            <div class="position-absolute border p-3 bg-white w-100 cvrOutput d-flex gap-3" style="top:100%;left:0;" *ngIf="!!cvrSearchOutput" (click)="spreadCVRoutput()">
                                <div class="mr-3 font-weight-bold">{{cvrSearchOutput.vat}}</div>
                                <div>{{cvrSearchOutput.name}}</div>
                            </div>
                        </div>
                        <div class="w-100">
                            <div class="text-muted text-small">{{ 'Standard.EAN' | translate }}</div>
                            <input type="text" class="form-control w-100" [(ngModel)]="customer.ean">
                        </div>
                      <div class="w-100">
                        <div class="text-muted text-small">{{ 'Standard.Name' | translate }}</div>
                        <input type="text" class="form-control w-100" [(ngModel)]="customer.customerName">
                      </div>
                      <div class="w-100 position-relative">
                        <div class="text-muted text-small">{{ 'Standard.Address' | translate }}</div>
                        <input id="customerAddressAddressInput" type="text" class="form-control w-100" [(ngModel)]="customer.customerAddress" (keyup)="customerAddress($event)" (focus)="customerAddressFocus = true" (blur)="delayedClose('customerAddress')">
                        <div class="position-absolute border bg-white w-100 addressOutput d-flex gap-3" style="top:100%;left:0;" *ngIf="!!customerAddressOutput && customerAddressFocus">
                            <div id="customerAdressContainer" class="w-100" style="max-height:35vh; overflow-y: auto;">
                                <div class="font-weight-bold border p-3 singleAddress" *ngFor="let address of customerAddressOutput; let i = index" [ngClass]="{ 'highlight': i == searchIndex }" (click)="spreadCustomerAddress(address)">{{address.tekst}}</div>
                            </div>
                        </div>
                      </div>
                      <div class="d-flex">
                        <div class="w-25">
                            <div class="text-muted text-small">{{ 'Standard.Zipcode' | translate }}</div>
                            <input id="customerAddressZipInput" type="text" class="form-control w-100" [(ngModel)]="customer.customerZipCode" (keyup)="customerZip($event)">

                        </div>
                        <div class="w-75 pl-3">
                            <div class="text-muted text-small">{{ 'Standard.City' | translate }}</div>
                            <input type="text" class="form-control w-100" [(ngModel)]="customer.customerCity">
                        </div>
                      </div>
                      <div class="w-100">
                        <div class="text-muted text-small">{{ 'Standard.Email' | translate }}</div>
                        <input id="customerAddressEmailInput" type="email" class="form-control w-100" [(ngModel)]="customer.customerEmail">
                      </div>
                      <div class="w-100">
                        <div class="text-muted text-small">{{ 'Standard.Phone' | translate }}</div>
                        <input type="text" class="form-control w-100" [(ngModel)]="customer.customerTelephone">
                      </div>
                      <div class="w-100">
                        <div class="text-muted text-small">{{ 'Standard.Mobile' | translate }}</div>
                        <input type="text" class="form-control w-100" [(ngModel)]="customer.customerMobile">
                      </div>
                    </div>
                </div>
                <div class="text-bold pt-3 cursor-pointer" (click)="otherInvoice = true" *ngIf="!otherInvoice">+ {{ 'Standard.OtherBillingAddress' | translate }}</div>

                <div class="card" *ngIf="otherInvoice">
                    <div class="card-header flex-between">
                        <div class="card-title">{{ 'Standard.Invoice' | translate }}</div>
                        <div class="d-flex gap-3">
                            <button class="btn btn-secondary" (click)="copyCustomerDataToInvoice()">{{ 'Buttons.CopyCustomerToInvoice' | translate }}</button>
                            <button type="button" (click)="otherInvoice = false; removeInvoiceAddress()" class="close">
                                <i class="fa fa-window-close red" aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>
                    <div class="card-body d-flex flex-column gap-3">
                        <div class="w-100">
                            <div>{{ 'Standard.Name' | translate }}</div>
                            <input type="text" class="form-control w-100" [(ngModel)]="customer.invoiceName">
                        </div>
                        <div class="w-100 position-relative">
                            <div>{{ 'Standard.Address' | translate }}</div>
                            <input type="text" class="form-control w-100" [(ngModel)]="customer.invoiceAddress" (keyup)="invoiceAddress($event)" (focus)="invoiceAddressFocus = true" (blur)="delayedClose('invoiceAddress')">
                            <div id="invoiceAddressAddressInput" class="position-absolute border bg-white w-100 addressOutput d-flex gap-3" style="top:100%;left:0;" *ngIf="!!customerAddressOutput && invoiceAddressFocus">
                                <div id="customerAdressContainer" class="w-100" style="max-height:35vh; overflow-y: auto;">
                                    <div class="font-weight-bold border p-3 singleAddress" *ngFor="let address of customerAddressOutput; let i = index" [ngClass]="{ 'highlight': i == searchIndex }" (click)="spreadInvoiceAddress(address)">{{address.tekst}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex">
                            <div class="w-25">
                                <div>{{ 'Standard.Zipcode' | translate }}</div>
                                <input type="text" class="form-control w-100" [(ngModel)]="customer.invoiceZipCode">
                            </div>
                            <div class="w-75 pl-3">
                                <div>{{ 'Standard.City' | translate }}</div>
                                <input type="text" class="form-control w-100" [(ngModel)]="customer.invoiceCity">
                            </div>
                        </div>
                        <div class="w-100">
                            <div>{{ 'Standard.Email' | translate }}</div>
                            <input id="invoiceAddressEmailInput" type="text" class="form-control w-100" [(ngModel)]="customer.invoiceEmail">
                        </div>
                        <div class="w-100">
                            <div>{{ 'Standard.Phone' | translate }}</div>
                            <input type="text" class="form-control w-100" [(ngModel)]="customer.invoiceTelephone">
                        </div>
                        <div class="w-100">
                            <div>{{ 'Standard.Mobile' | translate }}</div>
                            <input type="text" class="form-control w-100" [(ngModel)]="customer.invoiceMobile">
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer flex-between">
                <button class="btn btn-secondary" data-dismiss="modal" (click)="reset()">{{ 'Buttons.Close' | translate }}</button>
                <button class="btn btn-primary" data-dismiss="modal" (click)="saveCustomer()">{{ 'Buttons.Save' | translate }}</button>
            </div>
        </div>
    </div>
</div>